export default {
  name: 'support-portal',
  translationKey: 'support-portal-module',
  routePrefix: 'support-portal',
  routeNamePrefix: 'support-portal',
  directRoutesAvailable: true,
}
